import script from "./DataPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DataPanel.vue?vue&type=script&setup=true&lang=js"

import "./DataPanel.vue?vue&type=style&index=0&id=45b3f438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b3f438"]])

export default __exports__